import auth from '../action/authActions';
import { storeToken, storeUserInfo } from '../../authentication';
import { GetRequest } from '../../../utils/API'
import {jnEncrypt} from '../../../utils/General'
import {GET_USER_INFO} from "../../../utils/Endpoints";
import _ from 'lodash'
import {ROLES} from "../../../utils/DeliveryStatus";

export const initialState = ({
  isLoading: false,
  auth: null,
  status: null,
})

export default function (state = initialState, action) {
  switch (action.type) {

    case auth.TYPES.REQUEST_LOGIN: return Object.assign({}, state, { isLoading: true, auth: null, status: null })

    case auth.TYPES.LOGIN_SUCCESS:
      let token = _.get(action.payload, 'result.data.access_token', null)
      storeToken(token)
      GetRequest(GET_USER_INFO, {}).then(result => {
        if (result.data && result.data.code === 200) {
          const forSaveUser = {
            id: _.get(result, 'data.data.id'),
            name: _.get(result, 'data.data.name'),
            role: _.get(result, 'data.data.role'),
            username: _.get(result, 'data.data.username'),
          };

          const role = _.get(result, 'data.data.role')
          if(role.includes('ADMIN')) forSaveUser.role = 'ADMIN'
          if(role.includes('SUPER')) forSaveUser.role = 'SUPER_ADMIN'
          if(role.includes('CALL_CENTER')) forSaveUser.role = 'CALL_CENTER'
          if(role.includes('SENDER')) forSaveUser.role = 'SENDER'

          if(forSaveUser.role === ROLES.SENDER){
            forSaveUser.sender = {
              id: _.get(result, 'data.data.sender.id'),
              name: _.get(result, 'data.data.sender.name'),
              ownerName: _.get(result, 'data.data.sender.ownerName'),
              permissions: { inventory : _.get(result, 'data.data.sender.isShowInventory'), filterReceiver: _.get(result, 'data.data.sender.isShowReceiverName') },
            }
          }
          //console.log(forSaveUser);
          //forSaveUser.role = "CALL_CENTER"
          jnEncrypt(forSaveUser).then((value) => {
            storeUserInfo(value)
          });
        }
      })

      return Object.assign({}, state, {
        auth: action.payload.result.data,
        isLoading: false,
        status: {
          status: action.payload.result.status,
          message: ""
        }
      });

    case auth.TYPES.LOGIN_FAILED:
      return Object.assign({}, state, { auth: null, isLoading: false, status: { status: 400, message: "Invalid username or password! If you sure you have permission please contact your system administrator." } })

    default:
      return state
  }
}
